import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ButtonGhostV2, colors2 } from "oolib";

export const GuestLinks = ({ isSmallScreen }) => {

  const location = useLocation();
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/login", {
      state: { from: location.pathname + location.search }
    });
  };

  return (
    <div style={{ height: '100%', display: "flex", alignItems: "center" }}>
      <ButtonGhostV2 onClick={handleLoginClick} 
        typo="UI_BODY_SEMIBOLD_SM_DF"
        style={{ 
          background: location.pathname.includes("/login") ? colors2.grey10 : "unset",
          borderRadius: "37px",
          padding: isSmallScreen ? "1.2rem" : "0.9rem",
          paddingLeft: "1.6rem",
          paddingRight: "1.4rem" ,
        }}>
        Login
      </ButtonGhostV2>
    </div>
  );
};
